/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_OccupancyInputs */

const cs_investor_occupancy = /** @type {(inputs: Investor_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsazenost`)
};

const en_investor_occupancy = /** @type {(inputs: Investor_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occupancy`)
};

/**
* | output |
* | --- |
* | "Occupancy" |
*
* @param {Investor_OccupancyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_occupancy = /** @type {((inputs?: Investor_OccupancyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_OccupancyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_occupancy(inputs)
	return cs_investor_occupancy(inputs)
});